import { useMsal } from "@azure/msal-react";
import {
  Button,
  Heading,
  ImageBox,
  PageContainer,
  Text,
} from "@flixbus/honeycomb-react";
import React from "react";

import { apiAccessRequest } from "@/pages/Login/auth.config";

import welcomeImage from "@/assets/welcome-logo.svg";

import styles from "./Login.module.scss";

const appTitle = import.meta.env.VITE_TITLE;

export const Login: React.FC = () => {
  const { instance } = useMsal();
  const handleLogin = async () =>
    await instance.loginRedirect(apiAccessRequest);

  const textMessage = (
    <>
      <Heading size={1}>Welcome to {appTitle}</Heading>
      <Text>Please log in via the button below.</Text>
      <div className={styles.buttonContainer}>
        <Button appearance="primary" onClick={handleLogin}>
          Login to {appTitle}
        </Button>
      </div>
    </>
  );

  return (
    <div className={styles.container}>
      <PageContainer>
        <ImageBox
          img={{
            src: welcomeImage,
            alt: "login",
          }}
          extraClasses={styles.imageLink}
        >
          {textMessage}
        </ImageBox>
      </PageContainer>
    </div>
  );
};
